import { MouseEvent } from 'react';

declare global {
  interface Window {
    adobeDataLayer: unknown[];
    o2cmpConfigData?: CmpConfigData;
    o2cmpUserConsentInfo: string;
    denyMultiTabs: boolean;
  }
}

window.adobeDataLayer = window.adobeDataLayer || [];

interface CmpConfigData {
  cmpid: string;
  waitconsentimport: string;
  exponea: boolean;
  datalayer: string;
  variant: string;
}

interface TrackPageLoaded {
  language: string;
  pageId: string;
  pageTitle: string;
}

let adobeScript: HTMLScriptElement | null = null;
let cmpExponeaInlineScript: HTMLScriptElement | null = null;
let channel: BroadcastChannel | null = null;

const initScripts = (
  adobeLaunchPath: string,
  cmpId = '34520',
  cmpVersion = 'new_usersense',
  denyMultiTabs = true,
  broadcastChannelName = 'o2-moje-o2'
) => {
  window.denyMultiTabs = denyMultiTabs;
  if (!window.o2cmpConfigData) {
    window.o2cmpConfigData = {
      cmpid: cmpId,
      waitconsentimport: '900',
      exponea: true,
      datalayer: 'adobeDataLayer',
      variant: cmpVersion,
    };
  }

  if (!cmpExponeaInlineScript) {
    const scriptContent = `
      window.addEventListener("o2_consent_struct", function () {
        var o2cmpUserConsentInfo="";
        (function(k,l,m,n){window.cmp_datalayername=k.datalayer;window.cmp_waitforimport=k.waitconsentimport;window.gdprAppliesGlobally=!0;"cmp_id"in window||(window.cmp_id=o2cmpConfigData.cmpid);"cmp_params"in window||(window.cmp_params="");"cmp_host"in window||(window.cmp_host="cmp.o2.cz");"cmp_cdn"in window||(window.cmp_cdn="cmps.o2.cz");"cmp_cdn"in window||(window.cmp_proto="https:");window.cmp_getsupportedLangs=function(){var b="DE EN FR IT NO DA FI ES PT RO BG ET EL GA HR LV LT MT NL PL SV SK SL CS HU RU SR ZH TR UK AR BS".split(" ");if("cmp_customlanguages"in
        window)for(var c=0;c<window.cmp_customlanguages.length;c++)b.push(window.cmp_customlanguages[c].l.toUpperCase());return b};window.cmp_getRTLLangs=function(){return["AR"]};window.cmp_getlang=function(b){"boolean"!=typeof b&&(b=!0);if(b&&"string"==typeof cmp_getlang.usedlang&&""!==cmp_getlang.usedlang)return cmp_getlang.usedlang;b=window.cmp_getsupportedLangs();var c=[],a=location.hash,d=location.search,e="languages"in navigator?navigator.languages:[];if(-1!=a.indexOf("cmplang\x3d"))c.push(a.substr(a.indexOf("cmplang\x3d")+
        8,2).toUpperCase());else if(-1!=d.indexOf("cmplang\x3d"))c.push(d.substr(d.indexOf("cmplang\x3d")+8,2).toUpperCase());else if("cmp_setlang"in window&&""!=window.cmp_setlang)c.push(window.cmp_setlang.toUpperCase());else if(0<e.length)for(a=0;a<e.length;a++)c.push(e[a]);"language"in navigator&&c.push(navigator.language);"userLanguage"in navigator&&c.push(navigator.userLanguage);e="";for(a=0;a<c.length;a++){d=c[a].toUpperCase();if(-1!=b.indexOf(d)){e=d;break}-1!=d.indexOf("-")&&(d=d.substr(0,2));if(-1!=
        b.indexOf(d)){e=d;break}}if(""==e&&"string"==typeof cmp_getlang.defaultlang&&""!==cmp_getlang.defaultlang)return cmp_getlang.defaultlang;""==e&&(e="EN");return e=e.toUpperCase()};(function(){var b=document,c=window,a="",d="_en";if("cmp_getlang"in c){a=c.cmp_getlang().toLowerCase();if("cmp_customlanguages"in c)for(d=0;d<c.cmp_customlanguages.length;d++)if(c.cmp_customlanguages[d].l.toUpperCase()==a.toUpperCase()){a="en";break}d="_"+a}var e="cmp_proto"in c?c.cmp_proto:"https:",g="cmp_ref"in c?c.cmp_ref:
        location.href,f=b.createElement("script");f.setAttribute("data-cmp-ab","1");var h="";-1!=location.hash.indexOf("cmpdesign\x3d")?h=location.hash.substr(location.hash.indexOf("cmpdesign\x3d")+10,9999):-1!=location.search.indexOf("cmpdesign\x3d")&&(h=location.search.substr(location.search.indexOf("cmpdesign\x3d")+10,9999));-1!=h.indexOf("\x26")&&(h=h.substr(0,h.indexOf("\x26")));f.src=e+"//"+c.cmp_host+"/delivery/cmp.php?id\x3d"+c.cmp_id+"\x26h\x3d"+encodeURIComponent(g)+(""!=h?"\x26cmpdesign\x3d"+encodeURIComponent(h):
        "")+"\x26"+("cmp_params"in c?c.cmp_params:"")+(0<b.cookie.length?"\x26__cmpfcc\x3d1":"")+"\x26l\x3d"+a.toLowerCase()+"\x26o\x3d"+(new Date).getTime();f.type="text/javascript";f.async=!0;b.currentScript?b.currentScript.parentElement.appendChild(f):b.body?b.body.appendChild(f):(a=b.getElementsByTagName("body"),0==a.length&&(a=b.getElementsByTagName("div")),0==a.length&&(a=b.getElementsByTagName("span")),0==a.length&&(a=b.getElementsByTagName("ins")),0==a.length&&(a=b.getElementsByTagName("script")),
        0==a.length&&(a=b.getElementsByTagName("head")),0<a.length&&a[0].appendChild(f));f=b.createElement("script");f.src=e+"//"+c.cmp_cdn+"/delivery/js/cmp"+d+".min.js";f.type="text/javascript";f.setAttribute("data-cmp-ab","1");f.async=!0;b.currentScript?b.currentScript.parentElement.appendChild(f):b.body?b.body.appendChild(f):(a=b.getElementsByTagName("body"),0==a.length&&(a=b.getElementsByTagName("div")),0==a.length&&(a=b.getElementsByTagName("span")),0==a.length&&(a=b.getElementsByTagName("ins")),0==
        a.length&&(a=b.getElementsByTagName("script")),0==a.length&&(a=b.getElementsByTagName("head")),0<a.length&&a[0].appendChild(f))})();window.cmp_addFrame=function(b){if(!window.frames[b])if(document.body){var c=document.createElement("iframe");c.style.cssText="display:none";c.name=b;document.body.appendChild(c)}else window.setTimeout(window.cmp_addFrame,10,b)};window.cmp_rc=function(b){for(var c=document.cookie,a="",d=0;""!=c&&100>d;){for(d++;" "==c.substr(0,1);)c=c.substr(1,c.length);var e=c.substring(0,
        c.indexOf("\x3d")),g=-1!=c.indexOf(";")?c.substring(c.indexOf("\x3d")+1,c.indexOf(";")):c.substr(c.indexOf("\x3d")+1,c.length);b==e&&(a=g);e=c.indexOf(";")+1;0==e&&(e=c.length);c=c.substring(e,c.length)}return a};window.cmp_stub=function(){var b=arguments;__cmapi.a=__cmapi.a||[];if(b.length)if("ping"===b[0])if(2===b[1])b[2]({gdprApplies:gdprAppliesGlobally,cmpLoaded:!1,cmpStatus:"stub",displayStatus:"hidden",apiVersion:"2.0",cmpId:31},!0);else b[2]({gdprAppliesGlobally,cmpLoaded:!1},!0);else if("getUSPData"===
        b[0])b[2]({version:1,uspString:window.cmp_rc("")},!0);else if("getTCData"===b[0])__cmapi.a.push([].slice.apply(b));else if("addEventListener"===b[0]||"removeEventListener"===b[0])__cmapi.a.push([].slice.apply(b));else if(4==b.length&&!1===b[3])b[2]({},!1);else __cmapi.a.push([].slice.apply(b));else return __cmapi.a};window.cmp_msghandler=function(b){var c="string"===typeof b.data;try{var a=c?JSON.parse(b.data):b.data}catch(e){a=null}if("object"===typeof a&&null!==a&&"__cmpCall"in a){var d=a.__cmpCall;
        window.__cmp(d.command,d.parameter,function(a,g){a={__cmpReturn:{returnValue:a,success:g,callId:d.callId}};b.source.postMessage(c?JSON.stringify(a):a,"*")})}"object"===typeof a&&null!==a&&"__cmapiCall"in a&&(d=a.__cmapiCall,window.__cmapi(d.command,d.parameter,function(a,g){a={__cmapiReturn:{returnValue:a,success:g,callId:d.callId}};b.source.postMessage(c?JSON.stringify(a):a,"*")}));"object"===typeof a&&null!==a&&"__uspapiCall"in a&&(d=a.__uspapiCall,window.__uspapi(d.command,d.version,function(a,
        g){a={__uspapiReturn:{returnValue:a,success:g,callId:d.callId}};b.source.postMessage(c?JSON.stringify(a):a,"*")}));"object"===typeof a&&null!==a&&"__tcfapiCall"in a&&(d=a.__tcfapiCall,window.__tcfapi(d.command,d.version,function(a,g){a={__tcfapiReturn:{returnValue:a,success:g,callId:d.callId}};b.source.postMessage(c?JSON.stringify(a):a,"*")},d.parameter))};window.cmp_setStub=function(b){b in window&&("function"===typeof window[b]||"object"===typeof window[b]||"undefined"!==typeof window[b]&&null===
        window[b])||(window[b]=window.cmp_stub,window[b].msgHandler=window.cmp_msghandler,window.addEventListener("message",window.cmp_msghandler,!1))};window.cmp_addFrame("__cmapiLocator");window.cmp_addFrame("__cmpLocator");window.cmp_addFrame("__uspapiLocator");window.cmp_addFrame("__tcfapiLocator");window.cmp_setStub("__cmapi");window.cmp_setStub("__cmp");window.cmp_setStub("__tcfapi");window.cmp_setStub("__uspapi")})(o2cmpConfigData,"https://cmps.o2.cz/delivery/js/automatic.min.js","cmp.o2.cz","cmps.o2.cz");
        __cmp("addEventListener",["consent",function(a,b){a=__cmp("exportConsent");a!==o2cmpUserConsentInfo&&(o2cmpUserConsentInfo=a,o2cmpResult=__cmp("getCMPData"),!1!==window.o2cmpConfigData.exponea&&exponea.track("consent",{timestamp:Date.now(),source:"page",consentString:o2cmpUserConsentInfo,purposeConsents:JSON.stringify(o2cmpResult.purposeConsents),purposeLegitimateInterests:JSON.stringify(o2cmpResult.purposeLI),vendorConsents:JSON.stringify(o2cmpResult.vendorConsents),vendorLegitimateInterests:JSON.stringify(o2cmpResult.vendorLI)}))},!1],null);
      });
      (function(h,s){ h.appendChild(s);s.type='text/css';s.appendChild(document.createTextNode('.xnpe_async_hide{ opacity:0 !important}'));})(document.head||document.getElementsByTagName('head')[0],document.createElement('style'));
      !function(e,n,t,i,o,r){ function c(e){ if("number"!=typeof e)return e;var n=new Date;return new Date(n.getTime()+1e3*e)}var a=4e3,s="xnpe_async_hide";function p(e){ return e.reduce((function(e,n){ return e[n]=function(){ e._.push([n.toString(),arguments])},e}),{ _:[]})}function m(e,n,t){ var i=t.createElement(n);i.src=e;var o=t.getElementsByTagName(n)[0];return o.parentNode.insertBefore(i,o),i}function u(e){ return"[object Date]"===Object.prototype.toString.call(e)}r.target=r.target||"https://api-exponea.o2.cz",r.file_path=r.file_path||r.target+"/js/exponea.min.js",o[n]=p(["anonymize","initialize","identify","update","track","trackLink","trackEnhancedEcommerce","getHtml","showHtml","showBanner","showWebLayer","ping","getAbTest","loadDependency","getRecommendation","reloadWebLayers"]),o[n].notifications=p(["isAvailable","isSubscribed","subscribe","unsubscribe"]),o[n]["snippetVersion"]="v2.3.0",function(e,n,t){ e[n]["_"+t]={},e[n]["_"+t].nowFn=Date.now,e[n]["_"+t].snippetStartTime=e[n]["_"+t].nowFn()}(o,n,"performance"),function(e,n,t,i,o,r){ e[o]={ sdk:e[i],sdkObjectName:i,skipExperiments:!!t.new_experiments,sign:t.token+"/"+(r.exec(n.cookie)||["","new"])[1],path:t.target}}(o,e,r,n,i,RegExp("__exponea_etc__"+"=([\\w-]+)")),function(e,n,t){ m(e.file_path,n,t)}(r,t,e),function(e,n,t,i,o,r,p){ if(e.new_experiments){ !0===e.new_experiments&&(e.new_experiments={});var f,l=e.new_experiments.hide_class||s,_=e.new_experiments.timeout||a,d=encodeURIComponent(r.location.href.split("#")[0]);e.cookies&&e.cookies.expires&&("number"==typeof e.cookies.expires||u(e.cookies.expires)?f=c(e.cookies.expires):e.cookies.expires.tracking&&("number"==typeof e.cookies.expires.tracking||u(e.cookies.expires.tracking))&&(f=c(e.cookies.expires.tracking))),f&&f<new Date&&(f=void 0);var x=e.target+"/webxp/"+n+"/"+r[t].sign+"/modifications.min.js?http-referer="+d+"&timeout="+_+"ms"+(f?"&cookie-expires="+Math.floor(f.getTime()/1e3):"");"sync"===e.new_experiments.mode&&r.localStorage.getItem("__exponea__sync_modifications__")?function(e,n,t,i,o){ t[o][n]="<"+n+' src="'+e+'"></'+n+">",i.writeln(t[o][n]),i.writeln("<"+n+">!"+o+".init && document.writeln("+o+"."+n+'.replace("/'+n+'/", "/'+n+'-async/").replace("><", " async><"))</'+n+">")}(x,n,r,p,t):function(e,n,t,i,o,r,c,a){ r.documentElement.classList.add(e);var s=m(t,i,r);function p(){ o[a].init||m(t.replace("/"+i+"/","/"+i+"-async/"),i,r)}function u(){ r.documentElement.classList.remove(e)}s.onload=p,s.onerror=p,o.setTimeout(u,n),o[c]._revealPage=u}(l,_,x,n,r,p,o,t)}}(r,t,i,0,n,o,e),function(e,n,t){ e[n].start=function(i){ i&&Object.keys(i).forEach((function(e){ return t[e]=i[e]})),e[n].initialize(t)}}(o,n,r)}(document,"exponea","script","webxpClient",window,{ 
        target: "https://api-exponea.o2.cz",
        token: "5851ab46-b9d8-11e9-beef-92ec88286fd6",
        new_experiments: { mode: "sync" },
        debug: false,
        track: { 
          google_analytics: false,
        },
      });
      exponea.start();
    `;

    cmpExponeaInlineScript = document.createElement('script');
    cmpExponeaInlineScript.textContent = scriptContent;
    cmpExponeaInlineScript.async = true;

    document.head.appendChild(cmpExponeaInlineScript);
  }

  if (!adobeScript) {
    adobeScript = document.createElement('script');
    adobeScript.src = adobeLaunchPath;
    adobeScript.async = true;

    document.head.appendChild(adobeScript);
  }

  if (denyMultiTabs && !channel) {
    channel = new BroadcastChannel(broadcastChannelName);
    channel.postMessage('another-tab');
    channel.addEventListener('message', (msg) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const data = window.adobeDataLayer?.filter((e) => e?.hasOwnProperty('userInternal'));
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const isInternal = data[0]?.userInternal?.userType === 'internal';
      if (msg.data === 'another-tab' && isInternal && window.denyMultiTabs) {
        const overlayHtml = document.createElement('body');
        overlayHtml.innerHTML = `
				  <style>
  * {
    font-family: "Open Sans", sans-serif;
    margin: 0;
    padding: 0;
  }

  html, body {
    -webkit-font-smoothing: antialiased;
    font-family: "Open Sans", sans-serif;
    background: #0019A5;
    color: white;
  }

  h1 {
    font-style: normal;
    font-size: 32px;
    font-weight: 600;
    line-height: 42px;
  }

  a, a:visited {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-decoration: underline;
    color: white;
  }

  a:hover {
    text-decoration: none;
    color: white;
  }

  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
  }

  .error-text {
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    opacity: 0.5;
  }

  .mt {
    margin-top: 32px;
  }

  .app-bar {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    padding-top: 16px;
    padding-bottom: 16px;
    padding-left: 32px;
  }

  .logo {
    position: relative;
    height: 100%;
  }

  .logo svg {
    max-height: 32px;
  }

  .container {
    position: relative;
    width: 960px;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .container-text {
    display: flex;
    flex-direction: row;
    min-height: 500px;
    align-items: center;
  }

  .flex {
    display: flex;
    gap: 32px;
  }

  .flex-row {
    flex-direction: row;
  }

  .flex-grow {
    flex-grow: 1;
  }

  .p-32 {
    padding: 32px;
  }

  .buttons{
    display: flex;
    flex-direction: row;
    gap: 12px;
    margin-top: 32px;
  }

  .btn, .btn:visited {
    background: white;
    color: #0019A5;
    padding: 8px 16px 8px 16px;
    text-decoration: none;
    border-radius: 8px;
    text-align: center;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
  }

  .btn:hover {
    opacity: 0.9;
  }

  @media (max-width: 480px) {
    h1 {
      font-style: normal;
      font-size: 24px;
      font-weight: 600;
      line-height: 28px;
    }

    .app-bar {
      padding-top: 16px;
      padding-bottom: 16px;
      padding-left: 16px;
    }

    .logo svg {
      max-height: 24px;
    }

    .container {
      position: relative;
      width: 100%;
    }

    .container-text {
      min-height: 0;
    }

    .flex-row {
      flex-direction: column-reverse;
    }

    .p-32 {
      padding: 16px;
    }

    .mt {
      margin-top: 24px;
    }

    .btn{
      width: 100%;
    }
  }
</style>
          <div class="page">
            <div class="app-bar">
              <div class="logo">
                <svg viewBox="0 0 136 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M56.6408 4.91851H61.7515V0.0080532H56.6408V4.91851ZM96.235 14.8163C96.235 6.60653 100.811 1.04389 109.279 1.04389C117.631 1.04389 122.323 6.72164 122.323 14.8163C122.323 22.9109 117.707 28.742 109.279 28.742C100.735 28.742 96.235 23.0259 96.235 14.8163ZM101.804 14.8162C101.804 19.65 103.824 24.5221 109.279 24.5221C114.732 24.5221 116.754 19.65 116.754 14.8162C116.754 10.0976 114.58 5.26378 109.279 5.26378C103.977 5.26378 101.804 10.0976 101.804 14.8162ZM129.685 30.9977L130.829 30.0081C132.339 28.6962 135.703 25.5431 135.703 22.4129C135.703 19.2138 133.14 17.6947 129.571 17.6947C128.632 17.6947 127.122 17.8099 124.834 18.6384L124.994 21.9757C125.978 21.4003 127.809 20.8709 129.181 20.8709C130.463 20.8709 131.447 21.4694 131.447 22.8963C131.447 24.9017 128.222 27.6982 125.163 30.3508L125.163 30.3509L125.163 30.351L125.163 30.3511C124.922 30.56 124.682 30.7681 124.445 30.9748V34.0358H136V30.9977H129.685ZM73.8867 8.06427C67.7845 8.06427 64.7715 12.7829 64.7715 18.4991C64.7715 24.9824 68.5474 28.742 75.0312 28.742C77.777 28.742 79.9129 28.2049 81.7815 27.1692V22.9876C79.8748 24.0617 77.7389 24.9824 75.2596 24.9824C72.0942 24.9824 69.8822 23.1794 69.653 19.9952H83.2313C83.2313 13.0898 81.1716 8.06427 73.8867 8.06427ZM69.6531 16.4658C69.8822 13.8188 71.3313 11.8239 74.1921 11.8239C77.0528 11.8239 78.1966 13.9722 78.3489 16.4658H69.6531ZM53.5132 32.8086C56.2593 32.6551 56.6407 32.1181 56.6407 29.049V8.52472H61.7514V29.7395C61.7514 32.54 60.9505 36.7984 55.8397 36.7984C55.0006 36.7984 53.9709 36.6833 53.3225 36.4915L53.5132 32.8086ZM33.2512 18.5374C33.2512 12.0157 37.7135 8.06427 43.5108 8.06427C49.3462 8.06427 53.8085 12.0157 53.8085 18.5374C53.8085 24.2152 50.0326 28.742 43.5108 28.742C37.027 28.742 33.2512 24.2152 33.2512 18.5374ZM38.5907 17.9236C38.5907 21.1844 39.6205 24.7522 43.5108 24.7522C47.4391 24.7522 48.4688 21.2228 48.4688 17.9236C48.4688 14.8929 46.867 12.054 43.5108 12.054C40.1926 12.054 38.5907 14.9696 38.5907 17.9236ZM14.8745 21.7983H14.9508L21.282 1.50423H29.8252V28.2817H24.7145V6.18453H24.6382L17.468 28.2817H12.3573L5.18697 6.18453L5.11074 6.26127V28.2817H0V1.50423H8.54325L14.8745 21.7983Z"
                        fill="white"/>
                </svg>
              </div>
            </div>
            <div class="container">
              <div class="flex flex-row">
                <div class="flex-grow p-32 container-text">
                  <div>
                    <h1>Moje O2 podporuje pouze jeden otevřený tab</h1>
                    <p class="mt">Pokud jste otevřeli Moje O2 ve dvou záložkách, je nutné jednu z nich zavřít.</p>
                    <div class="buttons">
                      <a class="btn" href="/">Přejít na dashboard Moje O2</a>
                    </div>
                    <p class="error-text mt">Chyba 403: Forbidden</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
      `;
        document.body = overlayHtml;
      }
    });
  }
};

const getAdobeDataLayer = () => ({
  trackPageLoaded: (params: TrackPageLoaded) => {
    window.adobeDataLayer.push({ ...params, themeVersion: `O2 UI ${process.env.NPM_PACKAGE_VERSION}` });
    window.adobeDataLayer.push({ event: 'pageLoaded' });
  },
  trackButtonClick: (event: () => void) => (e: MouseEvent) => {
    window.adobeDataLayer.push({
      event: 'buttonClick',
      type: e.currentTarget.getAttribute('type'),
      element: e.currentTarget.getAttribute('data-elm'),
    });

    event();
  },
});

const multiTabs = () => ({
  allow: () => {
    window.denyMultiTabs = false;
  },
  deny: () => {
    window.denyMultiTabs = true;
  },
});

export { initScripts, getAdobeDataLayer, multiTabs };
